import { all, call, fork, put, take, takeLatest } from "redux-saga/effects";
import * as api from "../../utils/api";
import {
  clientActions,
  GET_ALLBRANDTOUCHPOINT_REQUEST,
  GET_HOME_TP_LIST_REQUEST,
  GET_CLIENT_REQUEST,
  GET_USERS_REQUEST,
} from "./actions";

export function* asyncGetClient({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getClient, payload);
    if (response.status === 200 && response.data) {
      yield put(clientActions.getClientSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetClient() {
  while (true) {
    const action = yield take(GET_CLIENT_REQUEST);
    yield* asyncGetClient(action);
  }
}

export function* asyncGetUsers({ resolve, reject }) {
  try {
    const response = yield call(api.getUsers);
    if (response.status === 200 && response.data) {
      yield put(clientActions.getUsersSuccess(response.data));
    }
  } catch (err) {
    reject(err);
  }
}

export function* watchGetUsers() {
  while (true) {
    const action = yield take(GET_USERS_REQUEST);
    yield* asyncGetUsers(action);
  }
}

export function* asyncGetHomeTPList({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getHomePageTPlist);
    if (response.status === 200 && response.data) {
      yield put(clientActions.getHomePageTPlistSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetAllStastics() {
  while (true) {
    const action = yield take(GET_HOME_TP_LIST_REQUEST);
    yield* asyncGetHomeTPList(action);
  }
}

export function* asyncGetAllBrandTouchPoints({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getAllBrandTp, payload);
    if (response.status === 200 && response.data) {
      yield put(clientActions.getAllBrandTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetAllBrandTouchPoints() {
  yield takeLatest(GET_ALLBRANDTOUCHPOINT_REQUEST, asyncGetAllBrandTouchPoints);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function* () {
  yield all([fork(watchGetClient), fork(watchGetAllStastics), fork(watchGetAllBrandTouchPoints), fork(watchGetUsers)]);
}
